function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Space, Form, Input, Button, Select, InputNumber, Modal, Alert, Radio, List, Divider } from "antd";
import { BoxFill } from "react-bootstrap-icons";
import Common from '../includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var TextArea = Input.TextArea;
var AddProvidingPurchaseOrder = function AddProvidingPurchaseOrder(_ref) {
  var handler = _ref.handler,
    provider = _ref.provider;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    itemOptions = _useState8[0],
    setItemOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    items = _useState0[0],
    setItems = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedItem = _useState10[0],
    setSelectemItem = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    loadError = _useState12[0],
    setLoadError = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataChanged = _useState14[0],
    setIsDataChanged = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItems = _useState16[0],
    setSelectedItems = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalCash = _useState18[0],
    setTotalCash = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    paymentTerms = _useState20[0],
    setpaymentTerms = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    reduction = _useState22[0],
    setReduction = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedPosId = _useState24[0],
    setSelectedPosId = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    shops = _useState26[0],
    setShops = _useState26[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setFormError('');
    setFormSuccess('');
    setSelectedPosId(values.point_of_sale_id);
    if (selectedItems.filter(function (i) {
      return i.value == values.sellable_id;
    }).length > 0) {
      var item = items.filter(function (i) {
        return i.id != values.sellable_id;
      })[0];
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id != values.sellable_id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != values.sellable_id;
      }));
      if (values.order_type == 0) {
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: item.id,
            label: item.label,
            quantity: extElementQuant + values.quantity,
            price: item.recharge_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + item.recharge_price * values.quantity;
        });
      } else {
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: item.id,
            label: item.label,
            quantity: extElementQuant + values.quantity,
            price: item.consignation_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + item.consignation_price * values.quantity;
        });
      }
    } else {
      var _item = items.filter(function (i) {
        return i.id == values.sellable_id;
      })[0];
      if (values.order_type == 0) {
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: _item.id,
            label: _item.label,
            quantity: values.quantity,
            price: _item.recharge_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + _item.recharge_price * values.quantity;
        });
      } else {
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: _item.id,
            label: _item.label,
            quantity: values.quantity,
            price: _item.consignation_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + _item.consignation_price * values.quantity;
        });
      }
    }
  };
  var handleCommentChange = function handleCommentChange(v) {
    setpaymentTerms(v.target.value);
  };
  var handleRc = function handleRc(v) {
    setReduction(v);
  };
  var createPo = function createPo() {
    setIsFormLoading(true);
    setFormError("");
    setFormSuccess("");
    var itemsArg = new Array();
    var itemsQuantityArg = new Array();
    var itemsPrices = new Array();
    selectedItems.forEach(function (i) {
      itemsArg.push(i.id);
      itemsQuantityArg.push(i.quantity);
      itemsPrices.push(i.price);
    });
    axios.post(Common.baseApiUrl + "addprovidingorder", {
      user_id: Common.currentUser.id,
      point_of_sale_id: selectedPosId,
      items: itemsArg,
      quantities: itemsQuantityArg,
      prices: itemsPrices,
      provider_id: provider.id.toString(),
      total_amount: totalCash
    }).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var handlePlus = function handlePlus(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: extElementQuant + 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev + item.price;
      });
    } else {
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev + item.price;
      });
    }
  };
  var handleMinus = function handleMinus(item) {
    //IF ITEM EXISTS IN THE LIST
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      //GET CURRENT QUANTITY
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      if (extElementQuant <= 0) {
        handleClearItem(item);
        return;
      }
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: extElementQuant - 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev - item.price;
      });
    }
  };
  var handleClearItem = function handleClearItem(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setTotalCash(function (prev) {
        return prev - item.price * extElementQuant;
      });
      //setSelectedItems(prev => [...prev, {id: item.id, label: item.label, quantity: extElementQuant + 1, base_price: item.base_price}]); 
    }
  };
  var handleCategoryChange = function handleCategoryChange(cid) {
    setItemOptions([]);
    items.filter(function (i) {
      return i.item_category_id == cid;
    }).forEach(function (i) {
      setItemOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: i.id,
          label: i.label
        }]);
      });
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      order_type: 0,
      quantity: 10
    });
    axios.all([axios.get(Common.baseApiUrl + 'getsellables/' + Common.currentUser.id.toString()), axios.get("".concat(Common.baseApiUrl, "getpointsofsale/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status != 200) return message.error({
        content: 'Une erreur est survenue pendant le chargement',
        delay: 4
      });
      setItemOptions([]);
      setItems([]);
      setItems(response[0].data.sellables);
      response[0].data.sellables.forEach(function (p) {
        if (p.provider_id == provider.id) setItemOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            value: p.id,
            label: p.label
          }]);
        });
      });
      if (response[0].data.status != 200) setDataError(response[0].data.message);
      setShops([]);
      response[1].data.pointsofsale.forEach(function (p) {
        setShops(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: p.label,
            value: p.id
          }]);
        });
      });
      if (response[1].data.pointsofsale.length > 0) form.setFieldsValue({
        point_of_sale_id: response[1].data.pointsofsale[0].id
      });
    })["catch"](function (error) {
      setDataError("Une erreur est survénue");
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loadError.length > 0 && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px 0px 10px 0px"
      },
      children: /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: loadError,
        showIcon: true
      })
    }), /*#__PURE__*/_jsxs(Form, {
      size: "medium",
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "point_of_sale_id",
        label: "PDV",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          preffix: /*#__PURE__*/_jsx(BoxFill, {}),
          options: shops
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "sellable_id",
        label: "Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          preffix: /*#__PURE__*/_jsx(BoxFill, {}),
          options: itemOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "order_type",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          block: true,
          options: [{
            label: "RECHARGE",
            value: 0
          }, {
            label: "CONSIGNATION",
            value: 1
          }],
          defaultValue: 0,
          optionType: "button"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "quantity",
        label: "Quantit\xE9",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          suffix: "Unit\xE9(s)",
          style: {
            width: '140px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: itemOptions.length == 0,
          size: "small",
          loading: isFormLoading,
          htmlType: "submit",
          type: "link",
          children: /*#__PURE__*/_jsx("b", {
            children: " AJOUTER"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        marginTop: "8px",
        padding: "6px",
        border: "1px dashed #2B5DA5",
        borderRadius: "8px"
      },
      children: [/*#__PURE__*/_jsx("h6", {
        children: /*#__PURE__*/_jsx("b", {
          children: "R\xE9sum\xE9 commande"
        })
      }), /*#__PURE__*/_jsx(List, {
        dataSource: selectedItems,
        itemLayout: "vertical",
        size: "small",
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                handlePlus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "+"
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "small",
              type: "link",
              disabled: item.quantity <= 1,
              onClick: function onClick() {
                handleMinus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "-"
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "small",
              type: "link",
              onClick: function onClick() {
                handleClearItem(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "X"
              })
            })],
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 15
              }),
              title: item.label,
              description: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Prix: "
                  }), item.price.toLocaleString("Fr")]
                }), /*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Qte: "
                  }), item.quantity]
                })]
              })
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "TOTAL : "
        }), (totalCash - reduction).toLocaleString("Fr")]
      })]
    }), /*#__PURE__*/_jsx("br", {}), ContextHolder, /*#__PURE__*/_jsx(Button, {
      type: "primary",
      disabled: selectedItems.length == 0,
      loading: isFormLoading,
      onClick: function onClick() {
        confirm({
          title: /*#__PURE__*/_jsx("b", {
            children: "Confirmer la cr\xE9ation de la commande?"
          }),
          content: /*#__PURE__*/_jsxs("div", {
            style: {
              marginTop: "8px",
              padding: "6px",
              border: "1px dashed #ED8042",
              borderRadius: "8px"
            },
            children: [/*#__PURE__*/_jsx("h6", {
              children: /*#__PURE__*/_jsxs("b", {
                children: ["R\xE9sum\xE9 commande - ", provider.label]
              })
            }), /*#__PURE__*/_jsx(List, {
              dataSource: selectedItems,
              itemLayout: "vertical",
              size: "small",
              renderItem: function renderItem(item, index) {
                return /*#__PURE__*/_jsx(List.Item, {
                  actions: [/*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      handlePlus(item);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "+"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    size: "small",
                    type: "link",
                    disabled: item.quantity <= 1,
                    onClick: function onClick() {
                      handleMinus(item);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "-"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    size: "small",
                    type: "link",
                    onClick: function onClick() {
                      handleClearItem(item);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "X"
                    })
                  })],
                  children: /*#__PURE__*/_jsx(List.Item.Meta, {
                    avatar: /*#__PURE__*/_jsx(BoxFill, {
                      size: 15
                    }),
                    title: /*#__PURE__*/_jsxs("span", {
                      style: {
                        fontSize: "14px"
                      },
                      children: [item.label, " | Qte: ", item.quantity, ", P.U: ", item.price.toLocaleString("Fr")]
                    })
                  })
                });
              }
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
              children: [/*#__PURE__*/_jsx("b", {
                children: "TOTAL : "
              }), totalCash.toLocaleString("Fr")]
            })]
          }),
          type: "warning",
          onOk: function onOk() {
            createPo();
          },
          okText: /*#__PURE__*/_jsx("b", {
            children: "Confirmer"
          }),
          cancelText: "Annuler"
        });
      },
      children: isFormLoading ? /*#__PURE__*/_jsx("b", {
        children: "CREATION DE LA COMMANDE EN COURS"
      }) : /*#__PURE__*/_jsx("b", {
        children: "BON POUR COMMANDE"
      })
    })]
  });
};
export default AddProvidingPurchaseOrder;